import type { Observable } from 'rxjs/Observable';
import { addSpanToAll } from '@atlaskit/react-ufo/interaction-metrics';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch/index.tsx';
import {
	type QueueId,
	fromQueueId,
} from '@atlassian/jira-servicedesk-queues-common/src/model/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (baseUrl: string, projectKey: string, queueId: QueueId): Observable<void> => {
	const fetchStartTime = performance.now();
	const queueIdStr = fromQueueId(queueId).toString();
	let url;

	if (fg('add-operation-query-param-to-queues-endpoints')) {
		const params = new URLSearchParams();
		params.set('queueId', queueIdStr);
		params.set('operation', 'fetchQueuesHistory');
		url = `${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues-history?${params.toString()}`;
	} else {
		// Keep original URL format when feature flag is off
		url = `${baseUrl}/rest/servicedesk/1/servicedesk/${projectKey}/queues-history?queueId=${queueIdStr}`;
	}

	const result = fetchJson$(url, { method: 'POST' });
	if (!fg('add-operation-query-param-to-queues-endpoints')) {
		addSpanToAll(
			'fetch',
			'rest/servicedesk/1/servicedesk/projectKey/queues-history?queueId=',
			[{ name: 'network' }],
			fetchStartTime,
			performance.now(),
		);
	}
	return result;
};
